import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgRight({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.99 12.149l.007-.067.003-.101-.004-.07-.016-.112-.03-.111-.043-.111-.053-.098-.067-.096a.997.997 0 00-.08-.09l-6-6a1 1 0 00-1.497 1.32l.083.094L15.587 11H6a1 1 0 00-.993.883L5 12a1 1 0 00.884.993L6 13h9.586l-4.293 4.293a1 1 0 00-.083 1.32l.083.094a1 1 0 001.32.083l.094-.083 6-6 .044-.046.053-.066.072-.11.053-.114.035-.105.025-.117z"
        fill={color}
      />
    </svg>
  )
}

export default SvgRight
